import React from 'react';

function EventEmptyStateIcon({ variant }) {
  const commonProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.85,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': 'true'
  };

  if (variant === 'invitations') {
    return (
      <svg {...commonProps}>
        <rect x="3" y="6" width="18" height="12" rx="2.5" />
        <path d="M4 8l8 6 8-6" />
        <path d="M10 4h4" />
      </svg>
    );
  }

  if (variant === 'pending') {
    return (
      <svg {...commonProps}>
        <path d="M8 3h8" />
        <path d="M8 21h8" />
        <path d="M9 3v4.2a3 3 0 0 0 .9 2.15L12 11.5l2.1-2.15A3 3 0 0 0 15 7.2V3" />
        <path d="M15 21v-4.2a3 3 0 0 0-.9-2.15L12 12.5l-2.1 2.15A3 3 0 0 0 9 16.8V21" />
      </svg>
    );
  }

  if (variant === 'upcoming') {
    return (
      <svg {...commonProps}>
        <rect x="3" y="5" width="18" height="16" rx="2.5" />
        <path d="M8 3v4M16 3v4M3 10h18" />
        <path d="M9.2 15.3l2 2 3.7-4.1" />
      </svg>
    );
  }

  if (variant === 'history') {
    return (
      <svg {...commonProps}>
        <circle cx="12" cy="13" r="7" />
        <path d="M12 9.8V13l2.6 1.6" />
        <path d="M5 6.5V3.5M5 3.5H2.5M5 3.5A10 10 0 0 1 22 11" />
      </svg>
    );
  }

  return (
    <svg {...commonProps}>
      <circle cx="12" cy="12" r="8" />
    </svg>
  );
}

export default EventEmptyStateIcon;
